import React from 'react';

import { BrowserRouter, Route, Switch } from 'react-router-dom';

import UserChoice from '~/pages/UserChoice/UserChoice';
import ResetPassword from '~/pages/ResetPassword/ResetPassword';
import ForceChangePassword from '~/pages/ForceChangePassword/ForceChangePassword';

// 𝘱𝘢𝘨𝘦𝘴 𝘵𝘩𝘢𝘵 𝘥𝘰𝘦𝘴𝘯'𝘵 𝘯𝘦𝘦𝘥 𝘢𝘶𝘵𝘩𝘦𝘯𝘵𝘪𝘤𝘢𝘵𝘪𝘰𝘯
const noAuthPagePaths = {
    userChoice: '/user_choice_noauth.php',
    forceChangePassword: '/force_change.php',
    resetPassword: '/password_reset.php'
};

// 𝘢 𝘥𝘦𝘳𝘪𝘷𝘦𝘥 𝘪𝘮𝘮𝘶𝘵𝘢𝘣𝘭𝘦 𝘭𝘪𝘴𝘵
export const noAuthPagePathsValues = Object.freeze(
    Object.values(noAuthPagePaths)
);

const NoAuthenticationRouter = () => {
    const uri = window.location.pathname;
    const basename = uri.substr(0, uri.lastIndexOf('/'));
    return (
        <BrowserRouter basename={basename}>
            <Switch>
                <Route
                    path={noAuthPagePaths.userChoice}
                    component={UserChoice}
                />
                <Route
                    path={noAuthPagePaths.forceChangePassword}
                    component={ForceChangePassword}
                />
                <Route
                    path={noAuthPagePaths.resetPassword}
                    component={ResetPassword}
                />
            </Switch>
        </BrowserRouter>
    );
};

export default NoAuthenticationRouter;
